import React from 'react';
import { Helmet } from 'react-helmet';
interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonical?: string;
  ogImage?: string;
}
export const SEO: React.FC<SEOProps> = ({
  title = 'Zakelijke website laten maken financieel adviseur | Noord Digital',
  description = 'Zakelijke website laten maken financieel adviseur? Noord Digital bouwt professionele WordPress websites voor de hele financiële dienstverlening. Van slimme instapoplossingen tot compleet maatwerk webdesign.',
  keywords = 'zakelijke website laten maken financieel adviseur, offerte website administratiekantoor, kosten professionele website accountantskantoor, webdesign financieel adviseur, WordPress website financiële dienstverlening, professionele website adviesbureau, zakelijke website maken, website laten bouwen accountant, administratiekantoor website, hypotheekadviseur website',
  canonical = 'https://noorddigital.nl',
  ogImage = 'https://noorddigital.nl/og-image.jpg'
}) => {
  return <Helmet data-id="element-601">
      {/* Primary Meta Tags */}
      <title data-id="element-602">{title}</title>
      <meta name="title" content={title} data-id="element-603" />
      <meta name="description" content={description} data-id="element-604" />
      <meta name="keywords" content={keywords} data-id="element-605" />
      <link rel="canonical" href={canonical} data-id="element-606" />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" data-id="element-607" />
      <meta property="og:url" content={canonical} data-id="element-608" />
      <meta property="og:title" content={title} data-id="element-609" />
      <meta property="og:description" content={description} data-id="element-610" />
      <meta property="og:image" content={ogImage} data-id="element-611" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" data-id="element-612" />
      <meta property="twitter:url" content={canonical} data-id="element-613" />
      <meta property="twitter:title" content={title} data-id="element-614" />
      <meta property="twitter:description" content={description} data-id="element-615" />
      <meta property="twitter:image" content={ogImage} data-id="element-616" />

      {/* Language */}
      <html lang="nl" data-id="element-617" />
    </Helmet>;
};